<div class="p-4 w-[420px] max-w-[92vw] text-white">
  <h2 class="text-lg font-semibold mb-3">{{ data.titulo }}</h2>

  <form [formGroup]="form" (ngSubmit)="salvar()" class="space-y-3">
    <mat-form-field class="w-full">
      <mat-label>{{ data.label }}</mat-label>
      <input #nomeInput matInput type="text" formControlName="nome" [attr.maxLength]="max" />
      <mat-hint align="end">{{ form.value.nome?.length || 0 }}/{{ max }}</mat-hint>

      <mat-error *ngIf="form.controls['nome'].hasError('required') || form.controls['nome'].hasError('whitespace')">
        O nome é obrigatório.
      </mat-error>
      <mat-error *ngIf="form.controls['nome'].hasError('maxlength')">
        Máximo de {{ max }} caracteres.
      </mat-error>
    </mat-form-field>

    <div class="flex justify-end gap-2 pt-1">
      <button type="button" mat-stroked-button color="basic" (click)="cancelar()">Cancelar</button>
      <button type="submit"
              mat-flat-button
              color="primary"
              [disabled]="form.invalid || (form.value.nome?.trim() === data.nomeAtual?.trim())">
        Salvar
      </button>
    </div>
  </form>
</div>
